import { IGetCentetUsersResponse } from './../interfaces/IGetCentetUsersResponse';
import axios from 'axios'
import { apiPaths } from 'src/core/urlTree'
import { useCustomAxios } from 'src/hook/axios/useCustomAxios'
import { IResBase } from 'src/services/base'
import { IGetUserByNationalCodeResponse } from '../interfaces'
import { IChangePasswordDto } from '../interfaces/IChangePasswordDto'



export const UserServices = () => {

  const {customAxios}=useCustomAxios();

  const getUserInfo = async () => {
    const response = await axios.get(apiPaths.GetUserInfo)
    return response.data
  }

  const GetUserByNationalCodeAsync = async (nationalCode: string) => {
    const response = await customAxios.get<IResBase<IGetUserByNationalCodeResponse>>(`User/GetUserByNationalCode/${nationalCode}`)
    return response.data
  }

  const GetCenterUsers = async (clinicId: number | undefined,officeId:number | undefined ) => {
    const response = await axios.get<IResBase<IGetCentetUsersResponse[]>>("user/GetCenterUsers",{params:{clinicId,officeId}})

    return response.data
  }

  return {
    getUserInfo,
    GetUserByNationalCodeAsync,
    GetCenterUsers
  }
}

export const ChangePasswordAsync = async (params: IChangePasswordDto) => {
  await axios.post('User/ChangePassword', params);

}